import React from 'react'

export default function ParamSyntax({children}) {
	return (
		<span style={{color: "var(--shiki-token-string-expression)"}}>
            "{children}"
		</span>
	)
}
